/**
 * The clean calculator boundary.
 *
 * A calculator is not a Payroll Preparation component. It owns its own
 * evidence, evaluation, review, and approval; the engine only determines
 * whether it is due and provides its payroll scope.
 */
export const CALCULATORS = Object.freeze({
  reviews: Object.freeze({id:"reviews",label:"Google Review Bonuses",route:"/payroll/calculators/google-reviews",reportKinds:Object.freeze(["reviews"])}),
  mt_membership: Object.freeze({id:"mt_membership",label:"MT Membership Bonus",route:"/payroll/calculators/mt-membership",reportKinds:Object.freeze(["memberships","memberships_payment"])}),
  enhancement: Object.freeze({
    id: "enhancement",
    label: "EG Enhancement",
    route: "/payroll/calculators/eg-enhancement",
    reportKinds: Object.freeze(["sales_service"]),
  }),
  tippy: Object.freeze({
    id: "tippy",
    label: "Tippy Gratuities",
    route: "/payroll/calculators/tippy-gratuities",
    reportKinds: Object.freeze(["tippy_gratuities"]),
  }),
  tippy_import: Object.freeze({
    id: "tippy_import",
    label: "Tippy Gratuities",
    route: "/payroll/calculators/tippy-gratuities",
    reportKinds: Object.freeze(["tippy_gratuities"]),
  }),
});

export function calculatorRoute(calculatorId, { boutique, period, cycle }) {
  const calculator = CALCULATORS[calculatorId];
  if (!calculator) return null;
  const query = new URLSearchParams();
  if (boutique) query.set("boutique", boutique);
  if (period) query.set("period", period);
  if (cycle) query.set("cycle", cycle);
  const search = query.toString();
  return search ? `${calculator.route}?${search}` : calculator.route;
}

export function calculatorForReport(reportKind, attachedCalculators = []) {
  return attachedCalculators
    .map((calculator) => CALCULATORS[calculator.id || calculator.cid])
    .find((calculator) => calculator?.reportKinds.includes(reportKind)) || null;
}
